import React, { FC, useEffect, useState } from "react";
import { Form, Space, Button, Input, Table, Modal, Switch, message } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { addTag, getTagList, getTag, updateTag, statusTag, deleteTag } from '@root/common/service';

const { TextArea } = Input;

interface DataType {
    createTime: string,
    description: string,
    id: number,
    instituteId: number,
    status: number,
    statusText: string,
    tagName: string,
    type: number,
    updateTime: string,
}

const Labelmanagement: FC = () => {
    const columns: ColumnsType<DataType> = [
        {
            title: '标签名称',
            dataIndex: 'tagName',
            key: 'tagName',
        },
        {
            title: '标签描述',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: '状态',
            dataIndex: 'statusText',
            key: 'statusText',
        },
        {
            title: '操作',
            key: 'address',
            width: 200,
            render: (_, record) => (
                <Space size="small">
                    <Button
                        type="link"
                        onClick={() => { onEditClickHandle(record) }}
                    >编辑</Button>
                    <Button
                        type="link"
                        onClick={() => { onChangeStatusClickHandle(record) }}
                    >{record.status === 1 ? '禁用' : '启用'}</Button>
                    <Button
                        type="link"
                        onClick={() => { onDeleteClickHandle(record) }}
                    >删除</Button>
                </Space>
            ),
        }
    ];

    const [form] = Form.useForm();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [formState, setFormState] = useState(true);
    const [tagList, setTagList] = useState<DataType[]>([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [tableTotal, setTableTotal] = useState(1);
    const [tablePageNum, setTablePageNum] = useState(1);
    const [editId, setEditId] = useState<null | number>(null)
    
    const handleOk = () => {
        form.validateFields().then((res: any) => {
            res.status = formState ? 1 : 0;
            if (editId !== null) {
                res.id = editId;
                updateTag(res).then(() => {
                    message.success('更新成功');
                    getList()
                    setIsModalVisible(false);
                    setEditId(null);
                    form.resetFields();
                })
            } else {
                addTag(res).then(() => {
                    message.success('新建成功');
                    getList()
                    setIsModalVisible(false);
                    form.resetFields();
                })
            }
            
        }).catch((err: any) => {
            message.error(err.errorFields[0].errors[0])
        })
    };
    const handleCancel = () => {
        form.resetFields();
        setIsModalVisible(false);
        setEditId(null);
    };

    const getList = async (page = tablePageNum, params?: object) => {
        setTableLoading(true);
        setTablePageNum(page);
        getTagList(
            { pageNum: page, pageSize: 10 },
            { ...params }
        ).then((res: any) => {
            const { data: { rows, total } } = res;
            setTagList(rows);
            setTableTotal(total);
        }).finally(() => {
            setTableLoading(false);
        });
    }

    const onEditClickHandle = async(data: DataType) => {
        React.startTransition(() => {
            setEditId(data.id);
        });
        getTag(data.id).then(res => {
            form.setFieldsValue({
                tagName: res.data.tagName,
                description: res.data.description
            })
            setFormState(res.data.status === 1);
            setIsModalVisible(true);
        })
    }

    const onChangeStatusClickHandle = async(data: DataType) => {
        statusTag({
            id: data.id,
            status: data.status === 1 ? 0 : 1
        }).then((res) => {
            if (data.status === 1) {
                message.success('禁用成功')
            } else {
                message.success('启用成功')
            }

            getList()
        })
    }

    const onDeleteClickHandle = async(data: DataType) => {
        Modal.confirm({
            title: '删除确认',
            content: '您确定删除吗？',
            okText: '确认',
            cancelText: '取消',
            onOk() {
                return new Promise((resolve, reject) => {
                    deleteTag(data.id).then(res => {
                        message.success('删除成功');
                        getList();
                        resolve('删除')
                    })
                    
                }).catch(() => console.log('Oops errors!'));
            }
        })
        
    }

    useEffect(() => {
        getList()
    }, [])

    return (
        <div className="coursemanage-tags">
            <div className="coursemanage-tags-option">
                <Button
                    type="primary"
                    onClick={() => { setIsModalVisible(true) }}
                >新建标签</Button>
            </div>
            <div className="coursemanage-table">
                <Table
                    rowKey="id"
                    loading={tableLoading}
                    columns={columns}
                    dataSource={tagList}
                    pagination={{
                        total: tableTotal,
                        onChange: (page) => {
                            getList(page);
                        },
                        showTotal: (total) => {
                            return "共" + total + "条记录";
                        },
                    }}
                />
            </div>

            {
                isModalVisible &&
                <Modal
                    title="编辑"
                    visible={isModalVisible}
                    onOk={handleOk}
                    onCancel={handleCancel}
                >
                    <div className="courseupload-editor">
                        <Form
                            form={form}
                            labelCol={{ span: 4 }}
                            wrapperCol={{ span: 20 }}
                            initialValues={{
                                state: false,
                            }}
                        >
                            <Form.Item
                                label="标签名称"
                                name="tagName"
                                rules={[
                                    {
                                        required: true,
                                        message: "请输入名称",
                                    },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                label="描述"
                                name="description"
                            >
                                <TextArea />
                            </Form.Item>
                            <Form.Item
                                label="状态"
                            >
                                <Switch
                                    checkedChildren="开启"
                                    unCheckedChildren="关闭"
                                    defaultChecked={formState}
                                    onChange={(checked) => {
                                        setFormState(checked)
                                    }}
                                />
                            </Form.Item>
                        </Form>
                    </div>
                </Modal>
            }
        </div>
    );
};

export default Labelmanagement;